import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "h-16 my-6",
  src: "https://uniti-bpo-website-assets.assets.unitiinternet.com/images/nf18mesh.png"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "h-16 my-6 ml-2",
  src: "https://uniti-bpo-website-assets.assets.unitiinternet.com/images/nf18mesh-extender.png"
}, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "h-16 my-6 ml-4",
  src: "https://uniti-bpo-website-assets.assets.unitiinternet.com/images/nf18mesh-extender.png"
}


import { PlusIcon } from '@heroicons/vue/outline';

type Product = {
  id: string,
  name: string,
  description: string,
  price: number
}


export default /*#__PURE__*/_defineComponent({
  props: {
    product: { type: Object, required: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.product.name.includes('NF18MESH'))
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : _createCommentVNode("", true),
    (__props.product.name.includes('NF18MESH-01') || __props.product.name.includes('NF18MESH-02'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(PlusIcon), { class: "ml-2 h-6 w-6 text-gray-900" }),
          _hoisted_4,
          (__props.product.name.includes('NF18MESH-02'))
            ? (_openBlock(), _createElementBlock("img", _hoisted_5))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})